module.exports = __webpack_public_path__ + "img/img_shuju.09f3b686.png";